import { SortBy } from '~/core/enums';
import {
  AvailableSortComponents,
  SelectedFilterOptions,
  TypeOfFilter,
} from '~/core/types/sortAndFilter';
import type { RootState } from '~/redux/store';

export const selectSortBy =
  (component: AvailableSortComponents) =>
  (state: RootState): SortBy =>
    state.sortAndFilter[component].sortBy;

export const selectFilters =
  (component: AvailableSortComponents) =>
  (state: RootState): TypeOfFilter[] =>
    state.sortAndFilter[component].filters;

export const selectSelectedFilters =
  (component: AvailableSortComponents) =>
  (state: RootState): SelectedFilterOptions =>
    state.sortAndFilter[component].selectedFilters;
